import React, { useEffect, useState } from "react";

import { Select } from "chakra-react-select";
import {
  Stack,
  Card,
  CardBody,
  CardFooter,
  Button,
  Spinner,
  Input,
  useToast,
  Radio,
  RadioGroup,
} from "@chakra-ui/react";

import PageDetailHeader from "components/PageDetailHeader/PageDetailHeader";

import useDocumentTitle from "hooks/useDocumentTitle";

import { GetSuppliers } from "services/SuppliersService";
import { GetRoles } from "services/RolesService";
import { PostNewUser } from "services/AdminUserManagementServices";

import { isValidEmail, isValidName, isNotEmpty } from "utils/ValidationUtils";

import InfoIcon from "@mui/icons-material/Info";
import check_icon from "assets/images/icons/check_icon.png";

import AdminAddNewUserBreadcrumbConstant from "constants/BreadCrumbConstants/AdminAddNewUserBreadcrumbConstant";
import FormErrorMessage from "components/FormErrorMessage/FormErrorMessage";

export default function AdminAddNewUser() {
  useDocumentTitle("Add New User");

  // Below is the sample for structure of select
  // const colourOptions = [
  //   { value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },
  //   { value: "blue", label: "Blue", color: "#0052CC", isDisabled: true },
  //   { value: "red", label: "Red", color: "#FF5630", isFixed: true },
  // ];

  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const [supplierList, setSupplierList] = useState([]);
  const [rolesList, setRolesList] = useState([]);

  const [selectSupplier, setSelectSupplier] = useState([]);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [userRole, setUserRole] = useState("");
  const [isActive, setIsActive] = useState("");

  const [errorText, setErrorText] = useState(["", "", "", "", ""]);

  const toast = useToast();

  useEffect(() => {
    const fetch_suppliers = async () => {
      try {
        const response = await GetSuppliers();
        const supplier_data = response.data.data;
        const selectSupplierList = supplier_data.map((supplier) => {
          return {
            value: supplier.supplier_id,
            label: supplier.supplier_name,
            class: supplier.supplier_class,
          };
        });

        setSupplierList(selectSupplierList);
      } catch (error) {
        console.log(error, " error");
      }
    };

    const getch_Roles = async () => {
      try {
        const response = await GetRoles();
        setRolesList(response.data);
      } catch (error) {
        console.log(error, " error");
      }
    };

    fetch_suppliers();
    getch_Roles();
  }, []);

  const verifyData = () => {
    let flag = true;

    let error_state = ["", "", "", "", ""];

    if (!isValidName(firstName)) {
      // setErrorText("Invalid First Name");
      error_state[0] = "Invalid First Name";
      flag = false;
    }

    if (!isValidName(lastName)) {
      // setErrorText("Invalid Last Names");
      error_state[1] = "Invalid Last Name";
      flag = false;
    }

    if (!isValidEmail(email)) {
      error_state[2] = "Invalid Email Address";
      flag = false;
    }

    if (!isNotEmpty(userRole)) {
      // setErrorText("User Role is required");

      error_state[3] = "User Role is required";
      flag = false;
      // return false;
    }

    setErrorText(error_state);

    return flag;
  };

  const handleNewUserSubmit = async (e) => {
    e.preventDefault();
    setLoadingSubmit(true);

    const formData = new FormData(e.target);

    try {
      if (!verifyData()) {
        setLoadingSubmit(false);
        return;
      }

      const res = await PostNewUser(formData, selectSupplier);

      setErrorText("User Created Successfully");

      toast({
        title: "User Created Successfully",
        status: "success",
        duration: 9000,
        isClosable: true,
      });

      setFirstName("");
      setLastName("");
      setEmail("");
      setUserRole("");
      setIsActive("");
      setSelectSupplier([]);

      setErrorText("");
    } catch (error) {
      console.log(error, "error");

      if (error.response) {
        setErrorText(error.response.data.message);
      } else {
        setErrorText("Server Error");
      }
    } finally {
      setLoadingSubmit(false);
    }

    console.log(formData, "formData");
  };

  console.log("supplierList  select", selectSupplier);

  return (
    <div className=" ">
      <Stack spacing={"2rem"}>
        <PageDetailHeader
          breadCrumbList={AdminAddNewUserBreadcrumbConstant}
          heading="Add New User"
        />

        <div className="flex flex-row justify-center   ">
          <Card
            sx={{
              paddingTop: "2rem",
              px: "2rem",
              width: "fit-content",
              height: "fit-content",
              my: "auto",
            }}
          >
            <form onSubmit={handleNewUserSubmit}>
              <CardBody>
                <div className="mb-2 flex flex-col gap-6 ">
                  <div className="flex  flex-col gap-6 md:flex-row justify-between">
                    <div className="md:w-[16rem]">
                      <p className="label">First Name</p>
                      <Input
                        name="first_name"
                        type="text"
                        className="input"
                        placeholder="Enter First Name"
                        isInvalid={errorText[0]
                          ?.toLowerCase()
                          ?.includes("first")}
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                      {errorText[0]?.toLowerCase()?.includes("first") && (
                        <FormErrorMessage errorMsg="Invalid First Name" />
                      )}
                    </div>
                    <div className="md:w-[16rem]">
                      <p className="label">Last Name</p>
                      <Input
                        name="last_name"
                        type="text"
                        className="input"
                        placeholder="Enter Last Name"
                        isInvalid={errorText[1]
                          ?.toLowerCase()
                          ?.includes("last")}
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                      {errorText[1]?.toLowerCase()?.includes("last") && (
                        <FormErrorMessage errorMsg="Invalid Last Name" />
                      )}
                    </div>
                  </div>
                  <div className="md:w-[33rem]">
                    <p className="label">Email</p>
                    <Input
                      name="email"
                      type="text"
                      className="input"
                      placeholder="abc@example.com"
                      isInvalid={errorText[2]?.toLowerCase()?.includes("email")}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {errorText[2]?.toLowerCase()?.includes("email") && (
                      <FormErrorMessage errorMsg="Invalid Email Address" />
                    )}
                  </div>
                  <div className="md:w-[33rem]  ">
                    <p className="label"> Select suppliers</p>
                    <Select
                      isMulti
                      isInvalid={errorText}
                      variant="outlineSelect"
                      options={supplierList}
                      value={selectSupplier}
                      onChange={setSelectSupplier}
                    />
                  </div>
                  <div className="md:w-[33rem]   ">
                    <p className="label">Select Role</p>
                    <RadioGroup
                      name="user_role"
                      isInvalid={errorText}
                      value={userRole}
                      onChange={setUserRole}
                    >
                      <Stack direction="row">
                        {rolesList.map((role) => {
                          return (
                            <Radio value={role.user_role_id}>
                              {role.user_role_name}
                            </Radio>
                          );
                        })}
                      </Stack>
                    </RadioGroup>
                    {errorText[3]?.toLowerCase()?.includes("role") && (
                      <FormErrorMessage errorMsg="User Role is required" />
                    )}
                  </div>
                  {/* <div className="md:w-[33rem]  ">
                    <p className="label">Select Status</p>
                    <RadioGroup
                      name="isActive"
                      isInvalid={errorText}
                      value={isActive}
                      onChange={setIsActive}
                    >
                      <Stack direction="row">
                        <Radio value={"1"}>Active</Radio>
                        <Radio value={"0"}>Inactive</Radio>
                      </Stack>
                    </RadioGroup>
                  </div> */}
                </div>
              </CardBody>
              <CardFooter>
                <div className="flex flex-row justify-end w-full ">
                  <div className="w-[11.4rem]">
                    <Button
                      type="submit"
                      variant="solid"
                      isDisabled={loadingSubmit}
                    >
                      {loadingSubmit ? (
                        <Spinner />
                      ) : (
                        <>
                          <img className="mr-2" src={check_icon} />
                          Create User
                        </>
                      )}
                    </Button>
                  </div>
                </div>
              </CardFooter>
            </form>
          </Card>
        </div>
      </Stack>
    </div>
  );
}
